export function fileURLToPath(u: string | URL): string {
  const s = String(u)
  if (s.startsWith("file://")) return decodeURIComponent(s.slice(7))
  // In the bundle `import.meta.url` is the page's URL; sibyl's root is /sibyl in the demo filesystem.
  return "/sibyl/"
}
export function pathToFileURL(p: string): URL {
  return new URL(`file://${p}`)
}
export default { fileURLToPath, pathToFileURL }
